import { createContext, useContext } from 'react'

export type RadioGroupContextValue = {
  name: string
  selectedValue: string
  disabled?: boolean
  darkMode?: boolean
  onValueChange?: (value: string) => void
}

export const RadioGroupContext = createContext<RadioGroupContextValue | null>(
  null,
)

export const useRadioGroupContext = (): RadioGroupContextValue | null =>
  useContext(RadioGroupContext)
